import { CheckCircle2 } from 'lucide-react'
import { Box, Stack, Typography } from '@mui/material'
import { BodyText, Notice, StepCard, StepTitle, SubHeading } from '../../components/ui'

function Checklist({ items }: { items: string[] }) {
  return (
    <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, display: 'grid', gap: 0.75 }}>
      {items.map((item) => (
        <Box component="li" key={item} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, fontSize: 14, color: '#1e293b' }}>
          <Box component="span" sx={{ color: '#3d6b7a', mt: '2px', flexShrink: 0 }}>
            <CheckCircle2 size={16} aria-hidden />
          </Box>
          {item}
        </Box>
      ))}
    </Box>
  )
}

/** Design manual p.2 — Onboarding Checklist. */
export function StepChecklist() {
  return (
    <StepCard>
      <StepTitle subtitle="Please have the following information available.">Before You Begin</StepTitle>
      <Stack spacing={3}>
        <Box>
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#0f172a', mb: 1.5 }}>Surplus Lines Licensee Details</Typography>
          <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' } }}>
            <Box>
              <SubHeading>Business Entities — Required</SubHeading>
              <Checklist items={['Resident State', 'Surplus Lines License Number', 'National Producer Number (NPN)', 'FEIN']} />
            </Box>
            <Box>
              <SubHeading>Individuals — Required</SubHeading>
              <Checklist
                items={[
                  'Full Legal Name (as shown on license)',
                  'Resident State',
                  'Surplus Lines License Number',
                  'National Producer Number (NPN)',
                ]}
              />
            </Box>
          </Box>
        </Box>

        <Box>
          <SubHeading>Designated Responsible Licensed Producer (DRLP)</SubHeading>
          <Checklist items={['DRLP by Entity', 'DRLP by State']} />
        </Box>

        <Box>
          <SubHeading>Surplus Lines Filing Credentials</SubHeading>
          <BodyText sx={{ mb: 1 }}>Provide login credentials where applicable:</BodyText>
          <Checklist items={['OPTins', 'State Filing Portals', 'NIPR-related systems', 'Other state-specific filing systems']} />
        </Box>

        <Notice tone="info">
          <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#0f172a' }}>Notice</Typography>
          You can save your work at any point during onboarding. When all information has been completed, select{' '}
          <strong>Send to MISC</strong>.
        </Notice>
      </Stack>
    </StepCard>
  )
}
